import HttpService, { fetchFile } from "../HttpService";
export const getReportData = async (params) => {
  const res = await HttpService({
    method: "GET",
    url: `/api/v2/user/user_group_orders`,
    params,
  });
  return res.data;
};

export const getGroupOrderPdf = async ({ id, creator_id }) => {
  const res = await fetchFile({
    method: "GET",
    url: `api/v2/group_order_invoices/${id}/go_report.pdf?creator_id=${creator_id}`,
    name: `order_${id}.pdf`,
  });
  return res.data;
};
export const getGroupsOfGroupOrderApi = async ({ user_id }) => {
  const res = await HttpService({
    method: "GET",
    url: `api/v2/users/${user_id}/groups`,
  });
  return res.data;
};
export const saveGroupOfGroupOrderApi = async ({ user_id, ...data }) => {
  const res = await HttpService({
    method: "POST",
    url: `api/v2/users/${user_id}/groups`,
    data
  });
  return res.data;
};
export const editGroupOfGroupOrderApi = async ({ user_id, group_order_id, ...data }) => {
  const res = await HttpService({
    method: "PUT",
    url: `api/v2/users/${user_id}/groups/${group_order_id}`,
    data
  });
  return res.data;
};
export const assignGroupOfGroupOrderApi = async ({ group_order_id, ...data }) => {
  const res = await HttpService({
    method: "PUT",
    url: `api/v2/group_orders/${group_order_id}/update_group_assignment`,
    data
  });
  return res.data;
};
export const deleteGroupOfGroupOrderApi = async ({ group_order_id, user_id }) => {
  const res = await HttpService({
    method: "DELETE",
    url: `api/v2/users/${user_id}/groups/${group_order_id}`,
  });
  return res.data;
};

export const duplicateGroupOrderApi = async ({ group_order_id }) => {
  const res = await HttpService({
    method: "POST",
    url: `/api/v2/group_orders/${group_order_id}/duplicate`,
  });
  return res.data;
};
